import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  FormControl,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
} from "@mui/material";
import { useState, useCallback, useEffect } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { red } from "@mui/material/colors";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/QualityAssurance";
import { useParams } from "react-router-dom";

const EditActivity = ({ onSuccess, id }) => {
  const { admToken, user } = useSelector((state) => state.auth);
  const { calendarId } = useParams()
  const [dateType, setDateType] = useState('single');
  const [loading, setLoading] = useState(false);
  

  const [formData, setFormData] = useState({
    name: '',
    schoolId: user?.schoolId || 0,
    activityDateType: 'single',
    activityDateFrom: '',
    activityDateTo: '',
  });

  const [activities, setActivities] = useState([
    {
      title: "",
      description: ""
    }
  ]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.getQASingleActivity(admToken, id);
      if (res.status && res.statusCode === 2) {
        if (res.status && res.statusCode === 2) {
          setFormData(res.data);
          setActivities(res.data.activityItems || [{ title: '', description: '' }]);
          setDateType(res.data.activityDateType || 'single');
        }
      } else {
        toast.error(res.data.message);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }, [admToken, id]);

  useEffect(() => {
    fetchData();
  }, [fetchData, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    setFormData(prev => ({
      ...prev,
      activityDateType: value,
      activityDateFrom: '',
      activityDateTo: '',
    }));
  };

  const handleActivityChange = (index, e) => {
    const { name, value } = e.target;
    const updatedActivities = [...activities];
    updatedActivities[index] = {
      ...updatedActivities[index],
      [name]: value
    };
    setActivities(updatedActivities);
  };

  const addActivity = () => {
    setActivities([...activities, { title: "", description: "" }]);
  };

  const removeActivity = (index) => {
    if (activities.length > 1) {
      const updatedActivities = [...activities];
      updatedActivities.splice(index, 1);
      setActivities(updatedActivities);
    }
  };

  const handleSubmit = useCallback(async () => {
    try {
      setLoading(true);
      const payload = {
        calendarId: Number(calendarId),
        name: formData.name,
        activityDateType: dateType,
        activityDateFrom: formData.activityDateFrom,
        activityDateTo: dateType === 'single' ? formData.activityDateFrom : formData.activityDateTo,
        activityItems: activities.map(a => ({ title: a.title, description: a.description })),
        id: id,
      };
      const res = await api.updateActivities(admToken, payload);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message || "Activity Successfully Added", {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        setFormData({
          name: '',
          schoolId: user?.schoolId || 0,
          sessionId: '',
          activityDateType: 'single',
          activityDateFrom: '',
          activityDateTo: '',
        });
        setActivities([{ title: '', description: '' }]);
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message)
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [admToken, formData, user?.schoolId, activities, dateType, onSuccess, id]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={dateType}
              onChange={handleDateTypeChange}
            >
              <FormControlLabel
                value="single"
                control={<Radio />}
                label="Single Date"
              />
              <FormControlLabel
                value="range"
                control={<Radio />}
                label="Date Range"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
              }}
            >
              {dateType === 'single' ? 'Activity Date' : 'Start Date'}
            </InputLabel>
            <TextField
              name="activityDateFrom"
              fullWidth
              size="small"
              type="datetime-local"
              value={formData.activityDateFrom}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>

        {dateType === 'range' && (
          <Grid item xs={12}>
            <Box>
              <InputLabel
                sx={{
                  mb: 1.5,
                  mt: 1,
                  fontSize: "12px",
                  fontWeight: "bolder",
                  color: "#000",
                  fontFamily: "Gilroy-Medium",
                }}
              >
                End Date
              </InputLabel>
              <TextField
                name="activityDateTo"
                fullWidth
                size="small"
                type="datetime-local"
                value={formData.activityDateTo}
                onChange={handleChange}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "1px solid #671E78",
                    },
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Grid>
        )}

        <Grid item xs={12}>
          <Box>
            <InputLabel
              sx={{
                mb: 1.5,
                mt: 1,
                fontSize: "12px",
                fontWeight: "bolder",
                color: "#000",
                fontFamily: "Gilroy-Medium",
                shadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
              }}
            >
              Name of Activity
            </InputLabel>
            <TextField
              name="name"
              fullWidth
              size="small"
              value={formData.name}
              onChange={handleChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "1px solid #671E78",
                  },
                },
              }}
            />
          </Box>
        </Grid>

        {activities.map((activity, index) => (
          <Grid container key={index} ml={1} mt={1}>
            <Grid item xs={12}>
              <Box>
                <InputLabel
                  sx={{
                    mb: 1.5,
                    mt: 1,
                    fontSize: "12px",
                    fontWeight: "bolder",
                    color: "#000",
                    fontFamily: "Gilroy-Medium",
                    shadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {index === 0 ? 'Activity Title' : `Additional Title ${index}`}
                </InputLabel>
                <TextField
                  name="title"
                  fullWidth
                  size="small"
                  value={activity.title}
                  onChange={(e) => handleActivityChange(index, e)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #671E78",
                      },
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box position="relative">
                <InputLabel
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1.5,
                    mt: 1,
                    fontSize: "12px",
                    fontWeight: "bolder",
                    color: "#000",
                    fontFamily: "Gilroy-Medium",
                    shadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {index === 0 ? 'Activity Description' : `Additional Description ${index}`}
                  {activities.length > 1 && (
                    <IconButton
                      onClick={() => removeActivity(index)}
                      sx={{
                        color: red[500],
                        pointerEvents: 'cursor',
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </InputLabel>
                <TextField
                  name="description"
                  fullWidth
                  size="small"
                  value={activity.description}
                  onChange={(e) => handleActivityChange(index, e)}
                  multiline
                  minRows={2}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #671E78",
                      },
                      "& textarea": {
                        minHeight: "80px",
                      },
                      padding: "8px",
                    },
                  }}
                  placeholder="Enter description here"
                />
              </Box>
            </Grid>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Button
            variant="outlined"
            onClick={addActivity}
            sx={{
              textTransform: "initial",
              mb: 2
            }}
          >
            Add More Activities
          </Button>
        </Grid>
      </Grid>

      <Box mt={5}>
        <Button
          variant="contained"
          fullWidth
          sx={{ textTransform: "initial" }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Activity"}
        </Button>
      </Box>
    </Box>
  );
};

export default EditActivity;